import type { DonutChartData } from '@silverfort/sf-components/dist/Charts/DonutChart/types';
import { AuthenticationType, AuthenticationTypeSummary } from '../../../types';
import { DIRECTORY_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { ChartColors } from '@silverfort/sf-components';

const AUTHENTICATION_TYPE_TO_COLOR = {
    ad: ChartColors['data-bg-main-1'],
    aad: ChartColors['data-bg-main-2'],
    radius: ChartColors['data-bg-main-3'],
    adfs: ChartColors['data-bg-main-4'],
    okta: ChartColors['data-bg-main-5'],
    pingfed: ChartColors['data-bg-main-6'],
    desktop_mfa: ChartColors['data-bg-main-7']
};

export const useAuthenticationTypeData = (
    onClick: (authenticationType: AuthenticationType) => void,
    summary?: AuthenticationTypeSummary[keyof AuthenticationTypeSummary]
): DonutChartData[] => {
    const filteredSummary = Object.entries(summary ?? {}).filter(([_, value]) => value > 0);

    return filteredSummary.map(([key, value]) => ({
        name: DIRECTORY_TYPES[key].displayName,
        value,
        fill: AUTHENTICATION_TYPE_TO_COLOR[key],
        onClick: () => onClick(key as AuthenticationType),
        tooltipContent: `${DIRECTORY_TYPES[key].displayName}: ${value}`,
        tooltipPlacement: 'top-start'
    }));
};
